import OptOutsIconSvg from '@/assets/svgs/main/opt-outs.svg';
import { AbbreviatedNumber } from '@/shared/components/AbbreviatedNumber';
import DetailsCard from '@/shared/components/DetailsCard';

interface OptOutsCardProps {
  leadsNatDnc: number;
  leadsStateDnc: number;
  leadsCellDnc: number;
  leadsMasterDnc: number;
  leadsAcctDnc: number;
  leadsInvalid: number;
}

export const OptOutsCard = ({
  leadsNatDnc,
  leadsStateDnc,
  leadsCellDnc,
  leadsMasterDnc,
  leadsAcctDnc,
  leadsInvalid,
}: OptOutsCardProps) => {
  return (
    <div className="mb-6">
      <DetailsCard icon={<OptOutsIconSvg className="h-5 w-5" />} title="Opt Outs">
        <div className="grid grid-cols-3 gap-0">
          <div className="border-r border-gray-200 p-4 text-left dark:border-gray-800">
            <div className="text-sm text-gray-500">National</div>
            <div className="text-3xl font-bold text-gray-900 dark:text-gray-300">
              <AbbreviatedNumber value={leadsNatDnc} />
            </div>
          </div>
          <div className="border-r border-gray-200 p-4 text-left dark:border-gray-800">
            <div className="text-sm text-gray-500">State</div>
            <div className="text-3xl font-bold text-gray-900 dark:text-gray-300">
              <AbbreviatedNumber value={leadsStateDnc} />
            </div>
          </div>
          <div className="p-4 text-left">
            <div className="text-sm text-gray-500">Cell</div>
            <div className="text-3xl font-bold text-gray-900 dark:text-gray-300">
              <AbbreviatedNumber value={leadsCellDnc} />
            </div>
          </div>
          <div className="border-t border-r border-gray-200 p-4 text-left dark:border-gray-800">
            <div className="text-sm text-gray-500">Master</div>
            <div className="text-3xl font-bold text-gray-900 dark:text-gray-300">
              <AbbreviatedNumber value={leadsMasterDnc} />
            </div>
          </div>
          <div className="border-t border-r border-gray-200 p-4 text-left dark:border-gray-800">
            <div className="text-sm text-gray-500">Account</div>
            <div className="text-3xl font-bold text-gray-900 dark:text-gray-300">
              <AbbreviatedNumber value={leadsAcctDnc} />
            </div>
          </div>
          <div className="border-t border-gray-200 p-4 text-left dark:border-gray-800">
            <div className="text-sm text-gray-500">Invalid</div>
            <div className="text-3xl font-bold text-gray-900 dark:text-gray-300">
              <AbbreviatedNumber value={leadsInvalid} />
            </div>
          </div>
        </div>
      </DetailsCard>
    </div>
  );
};
